<template lang="html">
  <div
    class="TheScreenSaver"
    :class="{'show-logo' : showLogo}"
  >
    <transition name="slide">
      <aside
        v-show="showSlide == 1"
        class="slide"
      >
        <Logo />
      </aside>
    </transition>
    <transition name="slide">
      <aside
        v-show="showSlide == 2"
        class="slide"
      >
        <p class="h2 url">www.bigtimer.net</p>
      </aside>
    </transition>
  </div>
</template>

<script>
import Logo from "./Logo";

export default {
  name: "TheScreenSaver",

  components: {
    Logo,
  },

  props: {
    slideDuration: {
      required: true,
      type: Number,
    },
  },

  data() {
    return {
      showLogo: false,
      slides: 2,
      showSlide: 1,
      slideTimer: null,
    };
  },

  mounted() {
    setTimeout(() => {
      this.showLogo = true;
      this.runSlideShow();
    }, 200);
  },

  beforeDestroy() {
    this.slideTimer = null;
  },

  methods: {
    runSlideShow() {
      this.slideTimer = setInterval(() => {
        if (this.showSlide < this.slides) this.showSlide++;
        else this.$emit("close");
      }, this.slideDuration * 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/abstracts/variables.scss";
@import "../style/abstracts/functions.scss";
@import "../style/abstracts/mixins.scss";

.TheScreenSaver {
  position: fixed;
  top: 0;
  width: 100vw;
  min-height: 100vh;
  min-height: -webkit-fill-available;

  background-color: $black;
  z-index: 100;

  cursor: none;
}
.url {
  font-size: 10vw;
  color: $color-primary;
}
.slide {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.with-motion {
  .slide-enter {
    opacity: 0;
    transform: scale(0.8);
  }
  .slide-enter-active {
    transition-property: opacity, transform;
    transition-duration: $duration-very-very-long + ms;
    transition-timing-function: ease-in-out;
  }
  .slide-enter-to,
  .slide-leave {
    opacity: 1;
    transform: scale(1);
  }
  .slide-leave-active {
    transition-property: opacity, transform;
    transition-duration: $duration-very-very-long + ms;
    transition-timing-function: ease-in-out;
  }
  .slide-leave-to {
    opacity: 0;
    transform: scale(1.5);
  }
}
</style>

<style lang="scss" >
@import "../style/abstracts/variables.scss";
@import "../style/abstracts/functions.scss";
@import "../style/abstracts/mixins.scss";

.TheScreenSaver {
  $initial-delay-1: 200;
  $interval-2: 100;
  $easing-1: cubic-bezier(0.18, 0.89, 0.32, 1.28);

  .logo {
    color: $color-primary;
    font-size: 3vmin;
  }

  .with-motion & {
    /* Transition start */
    .logo-line {
      opacity: 0;
      transform: scale(0.2);
      transition: opacity $duration-very-short + ms ease-in,
        transform $duration-short + ms $easing-1;
    }
    .logo-line-1 {
      transition-delay: $initial-delay-1 + ms;
    }
    .logo-line-2 {
      transition-delay: $initial-delay-1 + 1 * $interval-2 + ms;
    }
    /* Transition end */
    &.show-logo {
      .logo-line {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheScreensaver.vue